import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/pages/AuthCallback";
import Vision from "@/pages/Vision";
import SocialService from "@/pages/SocialService";
import Admin from "@/pages/Admin";

function AppRouter() {
    const location = useLocation();
    // Synchronously detect OAuth fragment BEFORE rendering normal routes to avoid races
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/vision" element={<Vision />} />
            <Route path="/social-service" element={<SocialService />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route
                path="/admin"
                element={
                    <ProtectedRoute>
                        <Admin />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />
            <Route path="*" element={<Home />} />
        </Routes>
    );
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ autoRaf: true, anchors: true });
        return () => lenis.destroy();
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRouter />
                    <Toaster
                        position="bottom-right"
                        toastOptions={{
                            style: {
                                background: "#5A111F",
                                color: "#FDFBF7",
                                border: "1px solid #B58A43",
                                fontFamily: "Spectral, serif",
                            },
                        }}
                    />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
